export default {
  routeNotFound: 'Saved url was not found',
};
